import { createApp } from "vue";
import { reactive } from "vue";
// @ts-ignore
import App from "./App.vue";
import router from "./router";
import { createBootstrap } from "bootstrap-vue-next";
import { FontAwesomeIcon } from "@/util/icons";
import { createGtm } from "@gtm-support/vue-gtm";

import AdminRoot from "./admin/AdminRoot.vue";
const adminPage = window.location.pathname.toLowerCase() === "/admin" || window.location.pathname.toLowerCase().startsWith("/admin/");
const app = createApp(adminPage ? AdminRoot : App);

import { Constants } from "./Constants";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
TimeAgo.addDefaultLocale(en);

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import AuthManager from "./AuthManager";
import Api from "./Api";

import "./app.scss";

import { datadogRum } from "@datadog/browser-rum";
import GlobalRefs from "./GlobalRefs";

import ScriptX from "vue-scriptx";
app.use(ScriptX);
import Ads from "vue-google-adsense";

// @ts-ignore
if (!adminPage) app.use(Ads.Adsense);

import "maz-ui/styles";

const firebaseConfig = {
    apiKey: "AIzaSyDo4XENkIEsJNiXMjS0WEzcBrj2C4A1J8A",
    authDomain: "auth.dateit.com",
    projectId: "dateit-446d1",
    storageBucket: "dateit-446d1.appspot.com",
    messagingSenderId: "769971709933",
    appId: "1:769971709933:web:c49a5fa81835c0b9a469e4",
    measurementId: "G-WPX054K21Z",
};

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Initialize Firebase
const fapp = initializeApp(firebaseConfig);
if (!adminPage) getAnalytics(fapp);

const api = reactive(new Api());
app.provide("api", api);
const authManager = reactive(new AuthManager(api));
authManager.start();
app.provide("authManager", authManager);
app.provide("globalRefs", reactive(new GlobalRefs()));

if (!adminPage)
    datadogRum.init({
        applicationId: "c0a989de-a826-485c-98e7-f388414c4818",
        clientToken: "pubc9b2c94dac12bee194df2efbf5fba3a5",
        site: "datadoghq.com",
        service: "dateit-web",
        env: "prod",
        // Specify a version number to identify the deployed version of your application in Datadog
        version: Constants.version,
        sessionSampleRate: 10,
        sessionReplaySampleRate: 50,
        trackUserInteractions: true,
        defaultPrivacyLevel: "mask-user-input",
    });

// Optionally install the BootstrapVue icon components plugin
app.use(Toast);
app.use(createBootstrap());

import VueGoogleMaps from "vue-google-maps-community-fork";

app.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyDo4XENkIEsJNiXMjS0WEzcBrj2C4A1J8A",
        // libraries: "places", // This is required if you use the Autocomplete plugin
    },
});

import InfiniteLoading from "v3-infinite-loading";
import "v3-infinite-loading/lib/style.css"; //required if you're not going to override default slots

app.component("infinite-loading", InfiniteLoading);

import Vue3linkify from "vue-3-linkify";
app.use(Vue3linkify);

app.use(router);
if (!adminPage)
    app.use(
        createGtm({
            id: "GTM-KWMKXMKF",
            vueRouter: router,
            trackViewEventProperty: "page-load",
        }),
    );
app.mount("#app");
if (!adminPage) datadogRum.startSessionReplayRecording();

// Register Font Awesome component
app.component("font-awesome-icon", FontAwesomeIcon);
